/* eslint import/prefer-default-export: 0 */

export const CHANGE_SELECTED_TASK_IDS = 'CHANGE_SELECTED_TASK_IDS';
export const CHANGE_SELECTED_PROPERTY_IDS = 'CHANGE_SELECTED_PROPERTY_IDS';
export const CHANGE_SELECTED_PERSON_IDS = 'CHANGE_SELECTED_PERSON_IDS';
